import mutators from '@/models'

const fields = [
  {
    name: 'Id',
    field: 'id',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 2,
    type: 'number',
    rules: {
      required: false
    }
  },
  {
    name: 'Nome',
    field: 'name',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 5,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Email',
    field: 'email',
    visible: false,
    sortable: false,
    filterable: true,
    filterWidth: 5,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Departamento',
    field: 'department',
    visible: true,
    sortable: true,
    filterable: true,
    filterWidth: 5,
    type: 'string',
    rules: {
      required: true
    }
  },
  {
    name: 'Password',
    field: 'password',
    visible: false,
    sortable: false,
    filterable: false,
    filterWidth: 6,
    type: 'string',
    rules: {
      required: false
    }
  },
  {
    name: 'Telemóvel',
    field: 'phone',
    visible: false,
    sortable: false,
    filterable: false,
    type: 'number',
    rules: {
      required: false
    }
  },
  {
    name: 'Data Inserção',
    field: 'created_at',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'date',
    rules: {
      required: false
    }
  },
  {
    name: 'Data Última Atualização',
    field: 'updated_at',
    visible: false,
    sortable: true,
    filterable: true,
    filterWidth: 6,
    type: 'date',
    rules: {
      required: false
    }
  },
  {
    name: 'Data Eliminação',
    field: 'deleted_at',
    visible: false,
    sortable: false,
    filterable: false,
    type: 'date',
    rules: {
      required: false
    }
  }
]

const rules = mutators.rules(fields)
const empty = mutators.empty(fields)
const filters = mutators.filters(fields)

export default {
  fields,
  rules,
  empty,
  filters
}
